import uuid from 'uuid'
import { ReactNode, useState } from 'react'
import { message } from 'antd'

import Link from '~/core/Link'
import DownloadWarningModal from '~/core/DownloadWarningModal'
import { isBlockedFileName, isUnknownExtFile } from '~/lib/fileExtensions'
import {
    BLOCKED_POPUPS_DOWNLOAD,
    DOWNLOAD_BLOCKED_ATTACHMENT_ERROR,
} from '~/lib/flashMsgs'

type SafeDownloadLinkPropsType = {
    children?: ReactNode
    dataKey?: string
    name?: string
    placement?: string
    disabled?: boolean
    style?: { [key: string]: string | number }
    downloadUrl?: string | null
    fileName?: string | null
    onClick?: Function
}

export default function SafeDownloadLink(props: SafeDownloadLinkPropsType) {
    const {
        children,
        dataKey,
        name,
        placement,
        disabled,
        style,
        downloadUrl,
        fileName,
        onClick,
        ...restProps
    } = props

    const [warningModalVisible, setWarningModalVisible] =
        useState<boolean>(false)

    const handleOnClick = (evt: Event) => {
        evt.preventDefault()
        if (onClick && typeof onClick === 'function') {
            onClick(evt)
        }
        if (isBlockedFileName(fileName || '')) {
            message.error(DOWNLOAD_BLOCKED_ATTACHMENT_ERROR)
            return
        }
        if (!downloadUrl) {
            return
        }
        if (!warningModalVisible && fileName && isUnknownExtFile(fileName)) {
            setWarningModalVisible(true)
            return
        }
        if (warningModalVisible) {
            setWarningModalVisible(false)
        }
        try {
            window.open(downloadUrl, '_blank', 'noopener')
        } catch {
            message.warn(BLOCKED_POPUPS_DOWNLOAD)
        }
    }

    return (
        <>
            {warningModalVisible && (
                <DownloadWarningModal
                    visible={warningModalVisible}
                    onConfirm={handleOnClick}
                    onClose={() => setWarningModalVisible(false)}
                />
            )}
            <Link
                key={dataKey || uuid.v4()}
                name={name}
                placement={placement}
                disabled={disabled}
                onClick={handleOnClick}
                style={style}
                {...restProps}
            >
                {children}
            </Link>
        </>
    )
}
